import Posts from './Posts';
import BookingServices from './BookingServices';
import Freebies from './Freebies';

export default {
    Posts,
    BookingServices,
    Freebies
}